<template>
  <figure
    class="before-after-augmented"
    @mousemove.prevent="onMouseMove"
    @touchstart="onMouseMove($event, true)"
    @touchmove="onMouseMove($event, true)"
    @click="onMouseMove($event, true)"
  >
    <div class="before-after-augmented__wrapper" :style="{ width: posX + 'px' }">
      <span class="before-after-augmented__label">{{ rightSlot.label }}</span>
      <slot :name="rightSlot.name" :dimensions="dimensions" :onresize="onResize"></slot>
    </div>
    <span class="before-after-augmented__label">{{ leftSlot.label }}</span>
    <slot :name="leftSlot.name" :dimensions="dimensions" :onresize="onResize"></slot>
    <div
      v-show="!hideAfter"
      class="before-after-augmented__handle"
      :style="{ left: posX + 'px' }"
      @mousedown.prevent="onMouseDown"
      @touchstart.prevent="onMouseDown"
    >
      <svg class="icon previous" aria-hidden="true">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-slider-previous" />
      </svg>
      <svg class="icon next" aria-hidden="true">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-slider-next" />
      </svg>
    </div>
  </figure>
</template>

<script>
export default {
  name: 'before-after-augmented',
  props: {
    beforeLabel: String,
    afterLabel: String,
    caroselColor: {
      type: String,
      default: 'white',
    },
  },
  data() {
    return {
      width: null,
      height: null,
      pageX: null,
      posX: null,
      isDragging: false,
      allowNextFrame: true,
    };
  },
  computed: {
    dimensions() {
      return {
        width: `${this.width}px`,
        height: 'auto',
      };
    },
    leftSlot() {
      return {
        name: this.$root.isRTL ? 'after' : 'before',
        label: this.$root.isRTL ? this.afterLabel : this.beforeLabel,
      };
    },
    rightSlot() {
      return {
        name: this.$root.isRTL ? 'before' : 'after',
        label: this.$root.isRTL ? this.beforeLabel : this.afterLabel,
      };
    },
  },
  created() {
    window.addEventListener('mouseup', this.onMouseUp);
    window.addEventListener('resize', this.onResize);
  },
  mounted() {
    this.onResize();
    this.$root.$on('before-after-augmented::update', () => {
      this.$forceUpdate();
    });
    document.documentElement.style.setProperty(
      '--before-after-augmented-slider-color',
      this.caroselColor,
    );
  },
  updated() {
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.onMouseUp);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      const currentWidth = this.width;

      this.width = this.$el.clientWidth;
      this.height = this.$el.clientHeight;

      if (currentWidth !== this.$el.clientWidth) {
        this.setInitialPosX();
      }
    },
    onMouseDown() {
      this.isDragging = true;
    },
    onMouseUp(e) {
      e.preventDefault();
      this.isDragging = false;
    },
    onMouseMove(e, isDragging = this.isDragging) {
      if (!isDragging || !this.allowNextFrame) {
        return;
      }

      this.allowNextFrame = false;
      this.pageX = e.pageX || e.targetTouches[0].pageX || e.originalEvent.targetTouches[0].pageX;
      window.requestAnimationFrame(this.updatePos);
    },
    updatePos() {
      const position = this.pageX - this.$el.getBoundingClientRect().left;

      switch (true) {
        case position >= this.width:
          this.posX = this.width;
          break;
        case position <= 0:
          this.posX = 0;
          break;
        default:
          this.posX = position;
      }

      this.allowNextFrame = true;
    },
    setInitialPosX() {
      this.posX = this.width / 2;
    },
  },
};
</script>
